import { render, staticRenderFns } from "./CaseMenu.vue?vue&type=template&id=6c96efbb&scoped=true&"
import script from "./CaseMenu.vue?vue&type=script&lang=js&"
export * from "./CaseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CaseMenu.vue?vue&type=style&index=0&id=6c96efbb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c96efbb",
  null
  
)

export default component.exports